// extracted by mini-css-extract-plugin
export default {"input":"FloatNumber_input__YtFhz","ant-input-number-group-wrapper-disabled":"FloatNumber_ant-input-number-group-wrapper-disabled__RVDqP"};